"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeRegularErr = exports.normalizeFieldErr = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("./constants");
var interfaces_1 = require("../common/interfaces");
/*
 * normalizeFieldError - normalizes field error
 *
 * Input format:
 * {
 *    "payment-method": "Card Declined - Invalid payment information. Please verify and enter again or try another card..",
 *    "billing-address": "Invalid Billing Address"
 * }
 *
 * Output format:
 * [
 *    {
 *       "message": "Card Declined - Invalid payment information. Please verify and enter again or try another card..",
 *       "field": "name on card",
 *       "code": "pmt200"
 *    },
 *    {
 *       "message": "Card Declined - Invalid payment information. Please verify and enter again or try another card..",
 *       "field": "name on card",
 *       "code": "pmt200",
 *       "type": "field"
 *    }
 * ]
 */
function normalizeFieldErr(errors) {
    if (!errors)
        return [];
    return errors.map(function (err) { return (tslib_1.__assign(tslib_1.__assign({}, err), { error_type: constants_1.ERROR_TYPE.FIELD, type: interfaces_1.ErrorType.SERVER })); });
}
exports.normalizeFieldErr = normalizeFieldErr;
/*
 * normalizeRegularErr - normalizes regular error
 *
 * Input format:
 * {
 *    "payment-method": "Card Declined - Invalid payment information. Please verify and enter again or try another card..",
 *    "billing-address": "Invalid Billing Address"
 * }
 *
 * Output format:
 * [
 *    {
 *       "message": "Card Declined - Invalid payment information. Please verify and enter again or try another card..",
 *       "source": "payment-method",
 *       "type": "general"
 *    },
 *    {
 *       "message": "Invalid Billing Address",
 *       "source": "billing-address",
 *       "type": "general"
 *    }
 * ]
 */
function normalizeRegularErr(errors) {
    if (!errors)
        return [];
    var normalizedErr = [];
    for (var source in errors) {
        /* istanbul ignore next */ if (errors.hasOwnProperty(source)) {
            var message = errors[source];
            normalizedErr.push({
                message: message,
                error_type: constants_1.ERROR_TYPE.GENERAL,
                source: source,
                type: interfaces_1.ErrorType.SERVER,
            });
        }
    }
    return normalizedErr;
}
exports.normalizeRegularErr = normalizeRegularErr;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/methodOfPaymentAPI/util.js
// module id = 3392
// module chunks = 11